import axios from 'axios'
import vue from '../main'

const instance = axios.create({
  baseURL: '/mgr',
  timeout: 5000
})

// 请求拦截处理
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 返回拦截处理
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    if (response.status === 200) {
      let code = response.data.code
      if (code === 0) {
        if (vue.$route.name === 'login') {
          vue.$router.push('/home')
        }
        return response.data.data
      } else if (code === 30001) {
        vue.$store.commit('updateAdminInfo', {})
        if (vue.$route.name !== 'login') {
          vue.$router.push('/login')
        }
      } else {
        vue.$message({ message: response.data.message, type: 'error' })
        return response.data
      }
    } else {
      return {}
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

export const post = async (api, params, showLoadingToast = true) => {
  return new Promise((resolve, reject) => {
    setTimeout(function () {
      instance
        .post(api, params, {
          headers: {token: vue.$cookies.get('token')}
        })
        .then(res => {
          resolve(res || {})
        })
        .catch(error => {
          reject(error)
        })
    }, 5)
  })
}



// WEBPACK FOOTER //
// ./src/utils/RequestUtil.js